export const GET_PROVIDERS = "GET_PROVIDERS"
export const GET_PROVIDERS_SUCCESS = "GET_PROVIDERS_SUCCESS"
export const GET_PROVIDERS_ERROR = "GET_PROVIDERS_ERROR"

export const GET_CONNECTIONS = "GET_CONNECTIONS"
export const GET_CONNECTIONS_SUCCESS = "GET_CONNECTIONS_SUCCESS"
export const GET_CONNECTIONS_ERROR = "GET_CONNECTIONS_ERROR"